
import React from 'react';
import { TailSpin } from 'react-loader-spinner';
// import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import './_spinner.scss';

const Spinner = () => (
    <div style={{ width: 'min-content', margin: 'auto' }}>
        <TailSpin
            type="TailSpin"
            color="#5330c5"
            height={100}
            width={100}
        />
    </div>
);

export default Spinner;
